import { defineMessages } from 'react-intl';

export const patientAgentMessages = defineMessages({
  pinChat: { id: 'patientAgent.pinChat', defaultMessage: 'Pin alongside page' },
  unpinChat: {
    id: 'patientAgent.unpinChat',
    defaultMessage: 'Unpin to overlay',
  },
  pinChatUnavailable: {
    id: 'patientAgent.pinChatUnavailable',
    defaultMessage: 'Widen the window to pin chat alongside the page',
  },
  resizeChat: {
    id: 'patientAgent.resizeChat',
    defaultMessage: 'Resize chat panel',
  },
  scrollToBottom: {
    id: 'patientAgent.scrollToBottom',
    defaultMessage: 'Scroll to bottom',
  },
  openAgent: {
    id: 'patientAgent.openAgent',
    defaultMessage: 'Open patient agent',
  },
  newChat: { id: 'patientAgent.newChat', defaultMessage: 'New chat' },
  closeSidebar: {
    id: 'patientAgent.closeSidebar',
    defaultMessage: 'Close sidebar',
  },
  toggleSidebar: {
    id: 'patientAgent.toggleSidebar',
    defaultMessage: 'Toggle sidebar',
  },
  restoreContextualChat: {
    id: 'patientAgent.restoreContextualChat',
    defaultMessage: 'Restore contextual chat',
  },
  expandContextualChat: {
    id: 'patientAgent.expandContextualChat',
    defaultMessage: 'Expand contextual chat',
  },
  closeContextualChat: {
    id: 'patientAgent.closeContextualChat',
    defaultMessage: 'Close contextual chat',
  },
  askAnything: {
    id: 'patientAgent.askAnything',
    defaultMessage: 'Ask anything',
  },
  suggested: { id: 'patientAgent.suggested', defaultMessage: 'Suggested' },
  loadingConversation: {
    id: 'patientAgent.loadingConversation',
    defaultMessage: 'Loading conversation',
  },
  removeAttachment: {
    id: 'patientAgent.removeAttachment',
    defaultMessage: 'Remove attachment',
  },
  dropFiles: {
    id: 'patientAgent.dropFiles',
    defaultMessage: 'Drop files to attach',
  },
  removePatientScope: {
    id: 'patientAgent.removePatientScope',
    defaultMessage: 'Remove patient context',
  },
  patientRecord: {
    id: 'patientAgent.patientRecord',
    defaultMessage: 'Patient record',
  },
  addContext: { id: 'patientAgent.addContext', defaultMessage: 'Add context' },
  proposedRewrite: {
    id: 'patientAgent.proposedRewrite',
    defaultMessage: 'Proposed rewrite',
  },
  reselectRewrite: {
    id: 'patientAgent.reselectRewrite',
    defaultMessage: 'Reselect the original text to apply this rewrite.',
  },
  replaceSelection: {
    id: 'patientAgent.replaceSelection',
    defaultMessage: 'Replace selection',
  },
  insertBelow: {
    id: 'patientAgent.insertBelow',
    defaultMessage: 'Insert below',
  },
  discard: { id: 'patientAgent.discard', defaultMessage: 'Discard' },
  documentDraftCreated: {
    id: 'patientAgent.documentDraftCreated',
    defaultMessage: 'Document draft created',
  },
  documentUpdated: {
    id: 'patientAgent.documentUpdated',
    defaultMessage: 'Document updated',
  },
  discarding: { id: 'patientAgent.discarding', defaultMessage: 'Discarding…' },
  seesPatientStudies: {
    id: 'patientAgent.seesPatientStudies',
    defaultMessage: "Sees this patient's studies",
  },
  startConversation: {
    id: 'patientAgent.startConversation',
    defaultMessage: 'Start a conversation',
  },
  noOriginatingConversation: {
    id: 'patientAgent.noOriginatingConversation',
    defaultMessage:
      "No originating conversation is attached. Ask the agent to help with this document using the patient's available records.",
  },
  documentAssistantHint: {
    id: 'patientAgent.documentAssistantHint',
    defaultMessage:
      "Ask the agent to help draft or revise this document using the patient's available records.",
  },
  ariaLabelChat: {
    id: 'patientAgent.ariaLabelChat',
    defaultMessage: 'AI patient chat',
  },
  scopeThisPatient: {
    id: 'patientAgent.scopeThisPatient',
    defaultMessage: 'This patient only',
  },
  subtitleLoading: {
    id: 'patientAgent.subtitleLoading',
    defaultMessage: 'Loading patient context',
  },
  loadingPatientContext: {
    id: 'patientAgent.loadingPatientContext',
    defaultMessage: 'Loading patient context…',
  },
  toggleShowChat: {
    id: 'patientAgent.toggleShowChat',
    defaultMessage: 'Show chat',
  },
  toggleShowSessions: {
    id: 'patientAgent.toggleShowSessions',
    defaultMessage: 'Show sessions',
  },
  buttonNew: {
    id: 'patientAgent.buttonNew',
    defaultMessage: 'New',
  },
  sectionSessions: {
    id: 'patientAgent.sectionSessions',
    defaultMessage: 'Sessions',
  },
  threadArchived: {
    id: 'patientAgent.threadArchived',
    defaultMessage: 'This chat is archived. Unarchive it to send messages.',
  },
  messageAttachments: {
    id: 'patientAgent.messageAttachments',
    defaultMessage: 'Attachments',
  },
  attachFile: {
    id: 'patientAgent.attachFile',
    defaultMessage: 'Attach file',
  },
  uploadingAttachment: {
    id: 'patientAgent.uploadingAttachment',
    defaultMessage: 'Uploading…',
  },
  attachmentStillUploading: {
    id: 'patientAgent.attachmentStillUploading',
    defaultMessage: 'Please wait until the attachments finish uploading.',
  },
  attachToArchived: {
    id: 'patientAgent.attachToArchived',
    defaultMessage: 'This chat is archived. Unarchive it to attach files.',
  },
  attachFileTooLarge: {
    id: 'patientAgent.attachFileTooLarge',
    defaultMessage: '{name} is larger than 50 MB and cannot be attached.',
  },
  tooManyAttachments: {
    id: 'patientAgent.tooManyAttachments',
    defaultMessage:
      'A message can have up to {max} files. Remove some before attaching more.',
  },
  roleAgent: {
    id: 'patientAgent.roleAgent',
    defaultMessage: 'Agent',
  },
  roleError: {
    id: 'patientAgent.roleError',
    defaultMessage: 'Error',
  },
  composerPlaceholder: {
    id: 'patientAgent.composerPlaceholder',
    defaultMessage: 'Do anything',
  },
  shellGreeting: {
    id: 'patientAgent.shellGreeting',
    defaultMessage: 'Work with {name}',
  },
  welcomeGeneric: {
    id: 'patientAgent.welcomeGeneric',
    defaultMessage: 'Work with this patient',
  },
  scopeRemoveHint: {
    id: 'patientAgent.scopeRemoveHint',
    defaultMessage: 'Remove patient context from this message',
  },
  scopeDetachAllHint: {
    id: 'patientAgent.scopeDetachAllHint',
    defaultMessage: 'Remove all context from this message',
  },
  scopeRestoreHint: {
    id: 'patientAgent.scopeRestoreHint',
    defaultMessage: 'Attach {context} context',
  },
  scopeEntityReport: {
    id: 'patientAgent.scopeEntityReport',
    defaultMessage: 'This report',
  },
  scopeEntityDocument: {
    id: 'patientAgent.scopeEntityDocument',
    defaultMessage: 'This document',
  },
  scopeEntityEncounter: {
    id: 'patientAgent.scopeEntityEncounter',
    defaultMessage: 'This consultation',
  },
  unknownError: {
    id: 'patientAgent.unknownError',
    defaultMessage: 'Unknown error',
  },
  serviceUnavailable: {
    id: 'patientAgent.serviceUnavailable',
    defaultMessage:
      'The agent could not complete this request. Please try again or start a new session.',
  },
  thinking: {
    id: 'patientAgent.thinking',
    defaultMessage: 'Thinking…',
  },
  collapsedWorking: {
    id: 'patientAgent.collapsedWorking',
    defaultMessage: 'AI is working',
  },
  collapsedWriting: {
    id: 'patientAgent.collapsedWriting',
    defaultMessage: 'Writing response',
  },
  collapsedReady: {
    id: 'patientAgent.collapsedReady',
    defaultMessage: 'Response ready',
  },
  collapsedLastResponse: {
    id: 'patientAgent.collapsedLastResponse',
    defaultMessage: 'Last response',
  },
  collapsedLatestActivity: {
    id: 'patientAgent.collapsedLatestActivity',
    defaultMessage: 'Latest activity',
  },
  working: {
    id: 'patientAgent.working',
    defaultMessage: 'Working…',
  },
  workContextPatient: {
    id: 'patientAgent.workContextPatient',
    defaultMessage: 'Working from this patient.',
  },
  activityWorking: {
    id: 'patientAgent.activityWorking',
    defaultMessage: 'Working',
  },
  agentIsWorking: {
    id: 'patientAgent.agentIsWorking',
    defaultMessage: 'Agent is working…',
  },
  agentWorked: {
    id: 'patientAgent.agentWorked',
    defaultMessage: 'Agent worked',
  },
  agentWorkedFor: {
    id: 'patientAgent.agentWorkedFor',
    defaultMessage: 'Agent worked for {duration}',
  },
  activityFailed: {
    id: 'patientAgent.activityFailed',
    defaultMessage: '{label} — failed',
  },
  activityWorkCompleted: {
    id: 'patientAgent.activityWorkCompleted',
    defaultMessage: 'Completed work',
  },
  activitySearchingRecords: {
    id: 'patientAgent.activitySearchingRecords',
    defaultMessage: 'Searching patient records',
  },
  activitySearchedRecords: {
    id: 'patientAgent.activitySearchedRecords',
    defaultMessage: 'Searched patient records',
  },
  activityReadingReport: {
    id: 'patientAgent.activityReadingReport',
    defaultMessage: 'Reading patient report',
  },
  activityReadReport: {
    id: 'patientAgent.activityReadReport',
    defaultMessage: 'Read patient report',
  },
  activityReadingConsultation: {
    id: 'patientAgent.activityReadingConsultation',
    defaultMessage: 'Reading consultation',
  },
  activityReadConsultation: {
    id: 'patientAgent.activityReadConsultation',
    defaultMessage: 'Read consultation',
  },
  activityComparingReports: {
    id: 'patientAgent.activityComparingReports',
    defaultMessage: 'Comparing patient reports',
  },
  activityComparedReports: {
    id: 'patientAgent.activityComparedReports',
    defaultMessage: 'Compared patient reports',
  },
  activityReviewingImages: {
    id: 'patientAgent.activityReviewingImages',
    defaultMessage: 'Reviewing clinical images',
  },
  activityReviewedImages: {
    id: 'patientAgent.activityReviewedImages',
    defaultMessage: 'Reviewed clinical images',
  },
  activityFindingDocuments: {
    id: 'patientAgent.activityFindingDocuments',
    defaultMessage: 'Finding patient documents',
  },
  activityFoundDocuments: {
    id: 'patientAgent.activityFoundDocuments',
    defaultMessage: 'Found patient documents',
  },
  activityReadingDocument: {
    id: 'patientAgent.activityReadingDocument',
    defaultMessage: 'Reading patient document',
  },
  activityReadDocument: {
    id: 'patientAgent.activityReadDocument',
    defaultMessage: 'Read patient document',
  },
  activityCreatingDocument: {
    id: 'patientAgent.activityCreatingDocument',
    defaultMessage: 'Creating patient document',
  },
  activityCreatedDocument: {
    id: 'patientAgent.activityCreatedDocument',
    defaultMessage: 'Created patient document',
  },
  activityUpdatingDocument: {
    id: 'patientAgent.activityUpdatingDocument',
    defaultMessage: 'Updating patient document',
  },
  activityUpdatedDocument: {
    id: 'patientAgent.activityUpdatedDocument',
    defaultMessage: 'Updated patient document',
  },
  activityAnalyzingData: {
    id: 'patientAgent.activityAnalyzingData',
    defaultMessage: 'Analyzing patient data',
  },
  activityAnalyzedData: {
    id: 'patientAgent.activityAnalyzedData',
    defaultMessage: 'Analyzed patient data',
  },
  eventFailed: {
    id: 'patientAgent.eventFailed',
    defaultMessage: 'failed',
  },
  agentRunFailed: {
    id: 'patientAgent.agentRunFailed',
    defaultMessage: 'Agent run failed',
  },
  runNotStartedTitle: {
    id: 'patientAgent.runNotStartedTitle',
    defaultMessage: 'Request did not start',
  },
  runNotStarted: {
    id: 'patientAgent.runNotStarted',
    defaultMessage: 'The agent could not start this request. Please try again.',
  },
  approvalRequired: {
    id: 'patientAgent.approvalRequired',
    defaultMessage: 'Approval required',
  },
  approvalApprove: {
    id: 'patientAgent.approvalApprove',
    defaultMessage: 'Approve',
  },
  composerSend: {
    id: 'patientAgent.composerSend',
    defaultMessage: 'Send message',
  },
  approvalDisapprove: {
    id: 'patientAgent.approvalDisapprove',
    defaultMessage: 'Disapprove',
  },
  approvalSendFeedback: {
    id: 'patientAgent.approvalSendFeedback',
    defaultMessage: 'Send feedback',
  },
  approvalFeedbackPlaceholder: {
    id: 'patientAgent.approvalFeedbackPlaceholder',
    defaultMessage: 'Explain what the agent should change',
  },
  approvalApproved: {
    id: 'patientAgent.approvalApproved',
    defaultMessage: 'Approved',
  },
  approvalDisapproved: {
    id: 'patientAgent.approvalDisapproved',
    defaultMessage: 'Disapproved',
  },
  approvalFeedbackSent: {
    id: 'patientAgent.approvalFeedbackSent',
    defaultMessage: 'Feedback sent',
  },
  approvalFeedbackBack: {
    id: 'patientAgent.approvalFeedbackBack',
    defaultMessage: 'Back',
  },
  approvalDiffNewTemplate: {
    id: 'patientAgent.approvalDiffNewTemplate',
    defaultMessage: 'New template',
  },
  approvalDiffNewVersion: {
    id: 'patientAgent.approvalDiffNewVersion',
    defaultMessage: 'New version',
  },
  approvalDiffLoading: {
    id: 'patientAgent.approvalDiffLoading',
    defaultMessage: 'Loading the current version…',
  },
  approvalDiffAdded: {
    id: 'patientAgent.approvalDiffAdded',
    defaultMessage: 'New',
  },
  approvalDiffChanged: {
    id: 'patientAgent.approvalDiffChanged',
    defaultMessage: 'Changed',
  },
  approvalDiffRemoved: {
    id: 'patientAgent.approvalDiffRemoved',
    defaultMessage: 'Removed',
  },
  approvalDiffUnchanged: {
    id: 'patientAgent.approvalDiffUnchanged',
    defaultMessage:
      '{count, plural, one {# section unchanged} other {# sections unchanged}}',
  },
  approvalFieldSections: {
    id: 'patientAgent.approvalFieldSections',
    defaultMessage: 'Sections',
  },
  approvalFieldDocuments: {
    id: 'patientAgent.approvalFieldDocuments',
    defaultMessage: 'Documents',
  },
  approvalFieldName: {
    id: 'patientAgent.approvalFieldName',
    defaultMessage: 'Name',
  },
  approvalFieldTabTitle: {
    id: 'patientAgent.approvalFieldTabTitle',
    defaultMessage: 'Tab title',
  },
  approvalFieldDescription: {
    id: 'patientAgent.approvalFieldDescription',
    defaultMessage: 'Description',
  },
  approvalFieldType: {
    id: 'patientAgent.approvalFieldType',
    defaultMessage: 'Type',
  },
  approvalFieldLanguage: {
    id: 'patientAgent.approvalFieldLanguage',
    defaultMessage: 'Language',
  },
  approvalFieldRequired: {
    id: 'patientAgent.approvalFieldRequired',
    defaultMessage: 'Required',
  },
  approvalValueYes: {
    id: 'patientAgent.approvalValueYes',
    defaultMessage: 'Yes',
  },
  approvalValueNo: {
    id: 'patientAgent.approvalValueNo',
    defaultMessage: 'No',
  },
  approvalValueNone: {
    id: 'patientAgent.approvalValueNone',
    defaultMessage: '—',
  },
  approvalFieldFlexible: {
    id: 'patientAgent.approvalFieldFlexible',
    defaultMessage: 'Flexible',
  },
  approvalFieldStrict: {
    id: 'patientAgent.approvalFieldStrict',
    defaultMessage: 'Strict',
  },
  approvalInclusionAlways: {
    id: 'patientAgent.approvalInclusionAlways',
    defaultMessage: 'Always generated',
  },
  approvalInclusionOnDemand: {
    id: 'patientAgent.approvalInclusionOnDemand',
    defaultMessage: 'On demand',
  },
  onboardingShowMe: {
    id: 'patientAgent.onboardingShowMe',
    defaultMessage: 'Show me',
  },
  onboardingOtherPageQuestion: {
    id: 'patientAgent.onboardingOtherPageQuestion',
    defaultMessage: 'This tour was created on another page. Go there?',
  },
  onboardingOtherPageGo: {
    id: 'patientAgent.onboardingOtherPageGo',
    defaultMessage: 'Go to page',
  },
  onboardingOtherPageCancel: {
    id: 'patientAgent.onboardingOtherPageCancel',
    defaultMessage: 'Not now',
  },
  onboardingFallbackTitle: {
    id: 'patientAgent.onboardingFallbackTitle',
    defaultMessage: 'Guided walkthrough',
  },
  onboardingStepsCount: {
    id: 'patientAgent.onboardingStepsCount',
    defaultMessage: '{count, plural, one {# step} other {# steps}}',
  },
  onboardingNext: {
    id: 'patientAgent.onboardingNext',
    defaultMessage: 'Next',
  },
  onboardingBack: {
    id: 'patientAgent.onboardingBack',
    defaultMessage: 'Back',
  },
  onboardingFinish: {
    id: 'patientAgent.onboardingFinish',
    defaultMessage: 'Finish',
  },
});
